import { useEffect } from "react";

import { useNavigate } from "react-router-dom";
import { signOut } from "aws-amplify/auth";

import { useAuth } from "../context/AuthProvider";
import { deleteCookie } from "../helpers/cookie";
import { LOG_IN_COOKIE } from "../constants";

export default function Signout() {
  const nav = useNavigate();
  const { user, loading, refresh } = useAuth();

  useEffect(() => {
    doSignOut();
  }, []);

  const doSignOut = async () => {
    try {
      await signOut();
      await refresh();
    } catch (e) {
      //
    } finally {
      const usp = new URLSearchParams(window.location.search);
      const returnUrl = usp.get("return");
      deleteCookie(LOG_IN_COOKIE);
      if (returnUrl) {
        window.location.replace(returnUrl);
      } else {
        nav("/");
      }
    }
  };

  return <div></div>;
}
